//选择往来单位-- 可选择父级
import * as React from 'react';
import { Alert, Shadow } from '@/components';
import { Button, Table, Radio, Icon } from 'uiw';
import API from '@/utils/http';
import style from '../index.module.scss';

export default class CustomerParentShadow extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            columns: [
                {
                    title: () => (
                        <React.Fragment>
                            {this.state.prevId.length > 0 ?
                                <Icon type="left" onClick={this.backRoot.bind(this)} />
                                :
                                <p></p>
                            }
                        </React.Fragment>
                    ),
                    width: 60,
                    key: 'checked',
                    render: (text: any, key: any, rowData: any, rowNumber: number, columnNumber: number) => (
                        <div className={style.radioShadow}>
                            <div className={style.bg}></div>
                            <Radio name='customer' checked={rowData.checked}></Radio>
                        </div>
                    )
                },
                { title: '编号', width: 200, key: 'BUserCode' },
                {
                    title: '名称',
                    key: 'BFullName',
                    render: (text: any, key: any, rowData: any, rowNumber: number, columnNumber: number) => (
                        <p className="overflow">{rowData.Soncount > 0 ? '...' : ''}{rowData.BFullName}</p>
                    )
                }
            ],
            dataSource: [],
            prevId: [],       //上一层查询标识数组
            choosed: {},
        }
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.isOpen == true) {
            this.getData();
        }
    }

    onClose = () => {
        this.props.onClose && this.props.onClose();
    }

    onConfirm = () => {
        let { choosed } = this.state;
        this.props.onConfirm && this.props.onConfirm(choosed);
    }

    getData = (id?: any) => {
        let { isType } = this.props;
        let param = {
            mth: 'Btype',
            parid: id || '',
            onlyType: isType
        }
        API.postData(param, '/UI/selectType/ajax.ashx', (res: any) => {
            if (res.code) {
                Alert(res.msg);
                return;
            }
            var data = res.data;
            this.setState({
                dataSource: data.data
            })
        })
    }

    //选择行
    chooseItem = (data: any) => {
        //有子集

        this.setState({
            choosed: data
        })

    }

    //回到上一层
    backRoot = async () => {
        let { prevId } = this.state;
        let len = prevId.length;
        await this.getData(prevId[len - 2]);
        prevId.splice(len - 1, 1);
        this.setState({
            prevId
        })
    }
    //下一层
    nextLayer = () => {
        let { prevId, choosed } = this.state;
        prevId.push(choosed.BtypeID);
        console.log();
        this.setState({
            prevId,
            choosed: {}
        }, () => {
            this.getData(choosed.BtypeID);
        })
    }

    render() {
        let { isOpen } = this.props;
        let { columns, dataSource, choosed } = this.state;
        dataSource = dataSource.map((item: any, idx: number) => {
            const isChecked = choosed.BtypeID === item.BtypeID;
            return { checked: isChecked, ...item };
        });
        return (
            <Shadow
                title="选择客户下载父目录"
                isOpen={isOpen}
                height={400}
                onClose={this.onClose.bind(this)}
                footer={
                    <React.Fragment>
                        {choosed && choosed.Soncount > 0 &&
                            <Button type="primary" onClick={this.nextLayer.bind(this)}>下一层</Button>
                        }
                        <Button type="primary" onClick={this.onConfirm.bind(this)}>选择</Button>
                    </React.Fragment>
                }
            >
                <Table
                    className="custom-table custom-table-hasline"
                    columns={columns}
                    data={dataSource}
                    onCell={(rowData) => {
                        this.chooseItem(rowData);
                    }}
                />
            </Shadow>
        )
    }
}